<template>
    <div style="display:flex;align-items:center;">
        <div :style="{width:avatarWidth+'px','margin-right':avatarWidth?'8px':0}">
            <img v-if="avatar" :src="avatar" :style="{width:avatarWidth+'px'}" style="border-radius:5px;width: 100%;vertical-align: middle" />
        </div>
        <div @click="()=>{go(url)}" class="titlebox">
            <div class="title" v-html="title"></div>
            <div class="description" v-if="description" v-html="description"></div>
        </div>

    </div>

</template>

<script>
    export default {
        props: {
            avatar: {
                type: String
            },
            title: {
                type: String
            },
            description: {
                type: String
            },
            qrcode: {
                type: String
            },
            id: {
                type: Number
            },
            cart: {
                type: Object
            },
            type: {
                type: String
            },
            url: {
                type: String,
            },
            avatarWidth: {
                type: Number,
                default: 40
            },
        },
        mounted() {


        },
        data() {
            return {
                balls: [],
                speed: 3,
                target: {
                    x: 200,
                    y: -130
                }
            }
        },
        methods: {
            go(url) {
                if (url != undefined) {
                    window.open(url);
                }
            },
            completed(img) {
                img.style.display = "none"
            },

        }
    };

</script>

<style scoped>
    .qrcode {
        float: right;
        height: 20px;
        width: 20px;
    }

    .el-table_1_column_1 .cell {
        overflow: inherit !important;
    }

    .qrcode:hover {
        /* position: absolute;  */
        position: relative;
        z-index: 9999;
        transform: scale(4.7) translateY(1px);
        transition: 0.5s;
    }

    .el-table tr input[type="checkbox"] {
        margin-right: 10px !important;
    }

    .checkbox {
        margin-right: 10px;
    }

    .titlebox {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .titlebox:hover {
        cursor: pointer;
    }

    .titlebox>span:hover {
        cursor: pointer;
        color: skyblue;
    }

    .title {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center
    }

    .description {
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #666
    }

    .ball {
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: skyblue;
        z-index: 200000;
    }

    .targetEle {
        width: 40px;
        height: 40px;
        background-color: yellowgreen;
        transform: translate(580px, 600px)
    }

</style>



// WEBPACK FOOTER //
// src/components/_widget/AvatarName.vue